import { Button, Chip, Typography } from "@mui/material";
import { useCallback } from "react";
import { useCancelTimeSlotMutation } from "src/api/services/availabilityApi";
import { Column, TimeSlot } from "src/api/types";

const statusColorMap: Record<string, "success" | "primary" | "default"> = {
  available: "success",
  booked: "primary",
  cancelled: "default",
};
export const useColumns = (
  providerAvailabilityId: string | undefined,
): Column<TimeSlot>[] => {
  const [cancelTimeSlot] = useCancelTimeSlotMutation();
  const handleCancel = useCallback(
    (id: number) => {
      if (providerAvailabilityId != null) {
        cancelTimeSlot({
          id,
          providerAvailabilityId: Number(providerAvailabilityId),
        });
      }
    },
    [cancelTimeSlot, providerAvailabilityId],
  );

  return [
    {
      id: "date",
      label: "Date",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => new Date(row.start_at).toLocaleDateString(),
      render: (row) => (
        <Typography>{new Date(row.start_at).toLocaleDateString()}</Typography>
      ),
    },
    {
      id: "start_at",
      label: "Start",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) =>
        new Date(row.start_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      render: (row) => (
        <Typography>
          {new Date(row.start_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Typography>
      ),
    },
    {
      id: "end_at",
      label: "End",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) =>
        new Date(row.end_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      render: (row) => (
        <Typography>
          {new Date(row.end_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Typography>
      ),
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.status,
      render: (row) => (
        <Chip
          label={row.status}
          color={statusColorMap[row.status] ?? "default"}
          size="small"
        />
      ),
    },
    {
      id: "encounter_id",
      label: "Encounter",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) =>
        row.encounter_id != null ? row.encounter_id.toString() : "-",
      render: (row) => (
        <Typography>
          {row.encounter_id != null ? row.encounter_id.toString() : "-"}
        </Typography>
      ),
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.created_at,
      render: (row) => {
        return row.status === "booked" ? (
          <Button
            size="small"
            color="error"
            onClick={() => handleCancel(row.id)}
          >
            Cancel
          </Button>
        ) : null;
      },
    },
  ];
};
